// extracted by mini-css-extract-plugin
export const designSystem = "DesignSystems-module--designSystem--lMLDs";
export const designSystemInfo = "DesignSystems-module--designSystemInfo--1tU2N";
export const designSystemImage = "DesignSystems-module--designSystemImage--_eiOf";